<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  // import loginUtil from "@/util/loginUtil";

  export default {
    // mounted() {
    //   if (window.ActiveXObject || "ActiveXObject" in window) {
    //     if (loginUtil.IETipGet() !== "1") {
    //       this.showTip();
    //     }
    //   }
    // },
    methods: {
      showTip() {
        this.$confirm("为了更好的体验，推荐使用谷歌(Chrome)浏览器", "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "了解",
          cancelButtonText: "不再提醒",
        })
          .then(() => {})
          .catch((action) => {
            if (action === "cancel") {
              loginUtil.IETipSet();
            }
          });
      },
    },
  };
</script>
<style lang="scss">
#app {
  height: 100vh;
}
</style>
